module.exports = __webpack_public_path__ + "img/lpk_bo.6b18cab2.png";